import { DBConstants } from '../../_constants';
import { DBService } from '../../_services';
import { alertActions } from '../alertActions';

export const DBActions = {
    getAllDB,
};

function fetched() { return { type: DBConstants.DB_FETCHED } }
function fetching() { return { type: DBConstants.DB_FETCHING } }

function getAllDB() {
    return dispatch => {
        dispatch(fetching());

        DBService.getAllDB()
            .then(
                DB => {
                    dispatch(success(DB))
                    dispatch(fetched());
                },
                error => {
                    dispatch(fetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }; 
    function success(DB) { return { type: DBConstants.GET_DB, DB } }
}

